export const initialScrapeTaskPermission = {
    initialScrapeTaskView: "initial-scrape-task.view",
    initialScrapeTaskCreate: "initial-scrape-task.create",
    initialScrapeTaskUpdate: "initial-scrape-task.update",
    initialScrapeTaskDelete: "initial-scrape-task.delete",
    initialScrapeTaskStart: "initial-scrape-task.start",
    initialScrapeTaskOneTimeStart: "initial-scrape-task.one-time-start",
    initialScrapeTaskReschedule: "initial-scrape-task.reschedule",
    initialScrapeTaskScheduleButton: "scheduler.schedule-button",
    initialScrapeTaskKeywordsPerSiteButton: "scheduler.keywords-per-site-button",
    schedulerStartOptionDebugMode: "scheduler.start-option-debug-mode",
    schedulerStartOptionSandboxMode: "scheduler.start-option-sandbox-mode",
    schedulerStartOptionStoreHttpResponse: "scheduler.start-option-store-http-response",
    schedulerStartOptionDisableCache: "scheduler.start-option-disable-cache"
};
